// REACT_APP_BACKEND_URL points a local build at a local backend; production
// builds leave it unset.
export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || "https://codekiwi-app-backend.onrender.com";
